import * as React from 'react';
import Dialog from '@mui/material/Dialog';

export default function Modal({ open = false, setOpen = () => {}, event = () => {}, Children = null, size = 'md' }) {
  return (
    <div>
      <Dialog fullWidth maxWidth={size} open={open} onClose={event} className="col">
        {Children}
      </Dialog>
    </div>
  );
}
